export default __webpack_public_path__ + "static/media/lawn-doctors-home-intro-mobile.b26f565e.jpg";